var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.7v2.4a1.2 1.2 0 001.2 1.2h9.6a1.2 1.2 0 001.2-1.2v-2.4",
    stroke: "#212121",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 14.7a.6.6 0 001.2 0h-1.2zm1.2 0v-9h-1.2v9h1.2z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.7l-3-3-3 3",
    stroke: "#212121",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
export default SvgShare;